import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

import type { TBrowserVersion } from '../definitions'

/**
 * Broswer verziószámának elkérése.
 * @param ua - UserAgent.
 */
export default function getBrowserVersion (ua: string): TBrowserVersion {
  return userAgentParser.getBrowserVersion(ua)
}
